<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    persistent
    :overlay-opacity="0.8"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="orange white--text" style="font-size: 25px">
        <v-icon left large color="white">fa-sad-cry</v-icon>
        商品已售出
      </v-card-title>
      <v-card-text class="pa-5 text-center">
        <div>您來慢了一步，商品已被買走啦。</div>
        <v-btn outlined rounded color="pink" class="mt-4" @click="$func.goBack()">回上一頁</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>    
</template>

<script>

export default {
  data() {
    return {
      dialog: false,
    }
  },
}

</script>